var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23709 0C10.3808 3.1248 14.5242 6.25023 18.6706 9.37163C17.8559 9.99764 17.0266 10.6057 16.2091 11.2283C12.8851 13.7296 9.56355 16.234 6.23924 18.7349C6.22694 16.6539 6.23709 14.5725 6.23401 12.4915C4.15617 12.4912 2.07832 12.4912 0.000783009 12.4912C0.000167625 10.4101 -0.000755504 8.3291 0.00109065 6.24837C2.07863 6.24806 4.15648 6.24837 6.23401 6.24806C6.23586 4.16548 6.2294 2.08258 6.23709 0Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightExpand);
export default __webpack_public_path__ + "static/media/right-expand.2cd9f1baa2c37345242f8f32684ad0c3.svg";
export { ForwardRef as ReactComponent };